import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-950 text-secondary-100">
      <div className="px-4 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-heading font-bold text-xl text-background-50">17吃瓜社区</span>
            </div>
            <p className="text-sm leading-relaxed text-secondary-200 max-w-md">
              一个专心聊娱乐话题的中文讨论社区。影视、综艺、舞台、热点,在这里都能找到愿意坐下来好好聊的人。我们相信,不同角度的观点,才是一件事最有意思的地方。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-900 text-secondary-200">
                <i className="ri-mail-line"></i>
              </span>
              <a href="mailto:hello@17.cn" className="text-sm text-secondary-200 hover:text-background-50 transition-colors cursor-pointer">
                hello@17.cn
              </a>
            </div>
          </div>

          <nav aria-label="页脚导航">
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-base">快速导航</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="text-secondary-200 hover:text-background-50 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/topics" className="text-secondary-200 hover:text-background-50 transition-colors cursor-pointer">话题广场</Link></li>
              <li><Link to="/about" className="text-secondary-200 hover:text-background-50 transition-colors cursor-pointer">关于我们</Link></li>
              <li><Link to="/about#principles" className="text-secondary-200 hover:text-background-50 transition-colors cursor-pointer">社区原则</Link></li>
            </ul>
          </nav>

          <nav aria-label="热门分类">
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-base">热门分类</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/topics?category=film" className="text-secondary-200 hover:text-background-50 transition-colors cursor-pointer">影视热议</Link></li>
              <li><Link to="/topics?category=show" className="text-secondary-200 hover:text-background-50 transition-colors cursor-pointer">综艺现场</Link></li>
              <li><Link to="/topics?category=stage" className="text-secondary-200 hover:text-background-50 transition-colors cursor-pointer">舞台演出</Link></li>
              <li><Link to="/topics?category=net" className="text-secondary-200 hover:text-background-50 transition-colors cursor-pointer">网络热点</Link></li>
            </ul>
          </nav>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-secondary-300">© {year} 17吃瓜社区 · 内容由社区网友共同贡献</p>
          <p className="text-xs text-secondary-300">理性讨论 · 友善表达 · 尊重差异</p>
        </div>
      </div>
    </footer>
  );
}